<template>
  <el-dialog :before-close="noDialog" :fullscreen="dialogFullscreen" :visible.sync="dialog" title="所有包月">
    <el-table :data="records" stripe>
      <el-table-column label="名称" prop="name"/>
      <el-table-column label="剩余充电时长" prop="freeChargeNum"/>
      <el-table-column label="结束时间">
        <template #default="scope">
          {{ timeFormat(scope.row.endTime) }}
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="noDialog">退出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import getMemberAllMonthly from "@/api/device/member-monthly-manage/getMemberAllMonthly";
import dialogMixin from "@/mixin/dialogMixin";
import timeMixin from "@/mixin/timeMixin";

export default {
  name: "MemberAllMonthly",
  mixins: [dialogMixin, timeMixin],
  props: {
    memberId: Number,
    memberType: String
  },
  watch: {
    memberId() {
      this.fetchData();
    },
  },
  data() {
    return {
      records: []
    }
  },
  methods: {
    fetchData() {
      getMemberAllMonthly(this.memberId, this.memberType).then(res => {
        this.records = res.data;
      });
    },
  }
}
</script>
